import React, { useState } from "react";
import "./AlertProvLealtad.css";
import { TiDelete } from "react-icons/ti";

const AlertProvLealtad = () => {
  const [AlertProvLealtad, setAlertProvLealtad] = useState(true);

  const CloseAlert = () => {
    setAlertProvLealtad(false);
  };

  return (
    <>
      {AlertProvLealtad === true ? (
        <div className="boxalertprovLealtad">
          <p className="textalertprovLealtad">
            Te Pedimos por favor que cargues la factura de este mes
          </p>
          <TiDelete className="iconalertprovLealtad" onClick={CloseAlert} />
        </div>
      ) : null}
    </>
  );
};

export default AlertProvLealtad;
